import styles from "./styles.module.css";
import { MdVisibility, MdVisibilityOff, MdDragHandle } from "react-icons/md";
import { IoCaretForward, IoCaretDown } from "react-icons/io5";
import { useState, useEffect, useContext } from "react";
import { PageDisbatch } from "../../../contexts/page";
import { EditorDisbatch, EditorValue } from "../../../contexts/editor";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import DropTarget from "./droptarget";
import useBlockNames from "../../../utils/useblocknames.js";

export default function Layer({ block, level, path, noHide, accept }) {
  const [open, setOpen] = useState(false);
  const disbatch = useContext(PageDisbatch);
  const editorDispatch = useContext(EditorDisbatch);
  const editor = useContext(EditorValue);
  const { overlays } = useBlockNames();

  const toggleVisible = (e) => {
    e.stopPropagation();
    const _block = { ...block };
    _block.hidden = !_block.hidden;
    disbatch({ type: "replace", block: _block, path: path });
  };

  const setEditor = (e) => {
    e.stopPropagation();
    editorDispatch({
      type: "set",
      value: { block, path },
    });
  };

  const [{ isDragging }, dragRef, preview] = useDrag({
    item: {
      type: overlays.includes(block.component) ? "overlay" : "component",
      block: block,
      path: path,
    },
    collect: (monitor, props) => ({
      isDragging: !!monitor.isDragging(),
    }),
    canDrag: (dill, monitor) => {
      return block.component !== "Page";
    },
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
    <div>
      <div
        style={{ paddingLeft: 6 * level, opacity: isDragging ? 0.4 : 1 }}
        onClick={setEditor}
        className={
          editor?.block?.id === block.id
            ? `${styles.layer} ${styles.active}`
            : styles.layer
        }
      >
        {block.children.length > 0 ? (
          <Expander open={open} setOpen={setOpen} />
        ) : (
          <div style={{ width: 12 }} />
        )}
        <div className={styles.layerTitle}>{block.name}</div>
        {!noHide && (
          <>
            <span ref={dragRef}>
              <MdDragHandle style={{ fontSize: 24, cursor: "grab" }} />
            </span>
            <Visibility onClick={toggleVisible} visible={!block.hidden} />
          </>
        )}
      </div>
      <div
        className={open && !isDragging ? styles.childOpen : styles.childClose}
      >
        {block.children.map((c, index) => {
          return (
            <DropTarget
              level={level + 1}
              block={c}
              accept={accept}
              path={[...path, index]}
              key={c.id}
            >
              <Layer level={level + 1} path={[...path, index]} block={c} />
            </DropTarget>
          );
        })}
      </div>
    </div>
  );
}

const Expander = ({ open, setOpen }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };
  if (open) {
    return <IoCaretDown onClick={handleClick} className={styles.expandicon} />;
  }
  return <IoCaretForward onClick={handleClick} className={styles.expandicon} />;
};

const Visibility = ({ visible, onClick }) => {
  if (visible) {
    return <MdVisibility onClick={onClick} className={styles.toggleicon} />;
  }
  return <MdVisibilityOff onClick={onClick} className={styles.toggleicon} />;
};
